export const getActiveError = state => state.error.activeError;